import { MuteMotionSource } from 'motion/MuteMotionSource';
import * as React from 'react';
import { Soundtrack } from '../audio/Soundtrack';
import WaveformView from '../audio/WaveformView';
import { MotionSource } from '../motion/MotionSource';
import { MotionView } from './components/MotionView';

interface Props {
  width: number;
  height: number;
  motionSource: MotionSource;
}

export class MotionSourceWaveformView extends React.Component<Props> {
  render() {
    const { width, height, motionSource } = this.props;
    if (motionSource instanceof MuteMotionSource) {
      return (
        <MotionView width={width} height={height} motionSource={motionSource} />
      );
    } else {
      return (
        <WaveformView
          width={width}
          height={height}
          buffer={(motionSource as Soundtrack).audioBuffer}
        />
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/controller/MotionSourceWaveformView.tsx